<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<style>
@import "./app.css";
</style>

<script>
import "vue-resize/dist/vue-resize.css";

export default {
  name: "app",
  components: {},
};
</script>
